export const VT_LEGACY_URL = process.env.NEXT_PUBLIC_VT_LEGACY_URL || 'https://dashboard.villatravellers.com';
export const DEV_URL = process.env.NEXT_PUBLIC_VT_LEGACY_URL || 'https://devsite.villatravellers.com';

export const DEV_API_URL = process.env.DEV_API_URL || 'https://devsite.villatravellers.com/api/v1';
